/**
 * Lot H / BL3-007B — capacité effective d’un créneau Click & Collect.
 * Garder aligné avec backend/utils/clickAndCollectCapacite.js
 */

export function resolveEffectiveCapacite(creneau, maxCommandesParPlage) {
  const globalCap = Number(maxCommandesParPlage) > 0 ? Number(maxCommandesParPlage) : 2;
  const own = Number(creneau?.capacite);
  if (Number.isFinite(own) && own > 0) return own;
  const places = Number(creneau?.placesTotal);
  if (Number.isFinite(places) && places > 0) return places;
  return globalCap;
}

export function isCapaciteOverride(creneau, maxCommandesParPlage) {
  if (!creneau || creneau.autoGenerated) return false;
  const globalCap = Number(maxCommandesParPlage) > 0 ? Number(maxCommandesParPlage) : 2;
  const own = Number(creneau.capacite);
  return Number.isFinite(own) && own > 0 && own !== globalCap;
}
